import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Menu, Search, Bell, User, Sprout, ShieldCheck } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

const MainLayout = ({ children, title = 'Panel de Control' }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col lg:flex-row font-sans selection:bg-yellow-400 selection:text-slate-900">
      {/* Left Vertical Navigation Menu */}
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      {/* Main Content Workspace */}
      <div className="flex-1 flex flex-col min-w-0 bg-slate-100 min-h-screen">
        {/* Top Navigation / Header Bar */}
        <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b border-slate-200/80 shadow-xs px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileOpen(true)}
              className="lg:hidden p-2 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-100 transition-colors"
            >
              <Menu className="w-6 h-6" />
            </button>

            {/* Title & Context */}
            <div>
              <h1 className="text-lg sm:text-xl font-bold text-slate-900 tracking-tight flex items-center">
                {title}
              </h1>
              <p className="text-xs text-slate-500 font-medium hidden sm:block">
                SISCIAC &bull; Sistema de Información Agrícola Comunal
              </p>
            </div>
          </div>

          {/* Top Actions: Search, Notifications, Profile */}
          <div className="flex items-center space-x-3 sm:space-x-4">
            {/* Quick Search */}
            <div className="hidden md:flex items-center relative w-64">
              <Search className="w-4 h-4 text-slate-400 absolute left-3 pointer-events-none" />
              <input
                type="text"
                placeholder="Buscar cultivos, insumos..."
                className="w-full bg-slate-100 hover:bg-slate-200/60 focus:bg-white text-xs text-slate-800 pl-9 pr-4 py-2 rounded-xl border border-transparent focus:border-green-500 focus:outline-none transition-all"
              />
            </div>

            {/* Notification Bell */}
            <button
              className="p-2 rounded-xl text-slate-600 hover:text-slate-900 hover:bg-slate-100 relative transition-colors"
              title="Notificaciones"
            >
              <Bell className="w-5 h-5" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-yellow-500 ring-2 ring-white" />
            </button>

            {/* User Avatar Badge */}
            <div className="flex items-center space-x-2 pl-2 border-l border-slate-200">
              <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-green-600 to-emerald-700 text-yellow-300 flex items-center justify-center font-bold text-sm shadow-xs">
                {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
              </div>
              <div className="hidden sm:block text-left">
                <p className="text-xs font-bold text-slate-900 leading-tight truncate max-w-[120px]">
                  {user?.name || 'Usuario'}
                </p>
                <p className="text-[10px] text-green-700 font-semibold uppercase">
                  {user?.role === 'admin' ? 'Administrador' : 'Productor'}
                </p>
              </div>
            </div>
          </div>
        </header>

        {/* Page Main Content Area */}
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          {children}
        </main>

        {/* Footer */}
        <footer className="mt-auto bg-white border-t border-slate-200 py-4 px-6 text-center text-xs text-slate-500">
          <p className="font-medium">
            &copy; Diseñado por ARIBWEBDEV.SITE | Desarrollado por Alexander Infante
          </p>
        </footer>
      </div>
    </div>
  );
};

export default MainLayout;
